/**
 * Обрабатывает сырой список элементов меню из API.
 * - Добавляет фиктивную категорию "Вся категория" с общим количеством блюд.
 * - Устанавливает для "Всей категории" флаг stop_info в зависимости от фильтра.
 * - Рассчитывает и добавляет поле `count` (количество прямых дочерних блюд) для каждой реальной категории.
 *
 * @param {Array} elements - Массив элементов меню, полученный от API.
 * @param {Object} filters - Объект фильтров из state, нужен для проверки статуса.
 * @returns {Array} - Обработанный и обогащенный массив элементов меню.
 */
export const processMenuItems = (elements, filters) => {
    // Если массив пустой, сразу возвращаем его
    if (!Array.isArray(elements) || elements.length === 0) {
        return []
    }

    // Создаем копию, чтобы не мутировать исходные данные
    const processedElements = [...elements]

    const totalDishCount = processedElements.filter(
        item => item.type === 'dish'
    ).length

    // Добавляем фиктивный элемент "Вся категория"
    if (totalDishCount > 0) {
        const allCategoryItem = {
            type: 'all',
            id: 'all-category-pseudo-id',
            name: 'Вся категория',
            count: totalDishCount,
        }
        if (filters?.status === 'in_stoplist') {
            allCategoryItem.stop_info = {}
        }
        processedElements.unshift(allCategoryItem)
    }

    // Группируем дочерние элементы для эффективного подсчета
    const childrenMap = new Map()
    processedElements.forEach(el => {
        if (el.parent_id) {
            if (!childrenMap.has(el.parent_id)) {
                childrenMap.set(el.parent_id, [])
            }
            childrenMap.get(el.parent_id).push(el)
        }
    })

    // Считаем количество блюд для каждой реальной категории
    processedElements.forEach(el => {
        if (el.type === 'category') {
            const children = childrenMap.get(el.id) || []
            const dishCount = children.filter(
                child => child.type === 'dish'
            ).length
            el.count = dishCount
        }
    })

    return processedElements
}
